















































































































































































































































































































































































import { AppointmentApi } from '@/api/appointments';
import { Forbidden } from '@/api/responses/forbidden';
import editAppointmentOutcomeDialog from '@/components/appointments/edit-appointment-outcome-dialog.vue';
import viewAppointmentDialog from '@/components/appointments/view-appointment-dialog.vue';
import loading from '@/components/loading.vue';
import assignAdvisorDialog from '@/components/target-tracker/target-tracker-assign-advisor-dialog.vue';
import { TargetTrackerDetail } from '@/components/target-tracker/target-tracker-detail';
import targetTrackerDetailTable from '@/components/target-tracker/target-tracker-detail-table.vue';
import editPaymentDialog from '@/components/target-tracker/target-tracker-edit-payment-dialog.vue';
import { Appointment } from '@/shared/appointments/appointment';
import { TargetTrackerAdvisor } from '@/shared/target-tracker-advisor';
import { TargetTrackerAppointment } from '@/shared/target-tracker-appointment';
import { TargetTrackerAppointmentPayment } from '@/shared/target-tracker-appointment-payment';
import { TargetTrackerAppointmentPaymentType } from '@/shared/target-tracker-appointment-payment-type';
import { AppointmentPaymentStatusType } from '@/shared/types/appointment-payment-status-type';
import { User } from '@/shared/user';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const appointmentApi = new AppointmentApi();

const typesModule = namespace('types');
const userModule = namespace('user');

@Component({
    components: {
        editAppointmentOutcomeDialog,
        viewAppointmentDialog,
        loading,
        assignAdvisorDialog,
        targetTrackerDetailTable,
        editPaymentDialog,
    },
})
export default class TargetTrackerAdvisorTab extends Vue {
    @typesModule.Getter('activeAppointmentPaymentStatusTypes') private appointmentPaymentStatusTypes!: Array<AppointmentPaymentStatusType>;

    @userModule.Getter('user') private currentUser!: User;
    @userModule.Getter('isInternalKeyStakeholder') private isInternalKeyStakeholder!: boolean;
    @userModule.Getter('isHeadOfDepartment') private isHeadOfDepartment!: boolean;

    @Prop({ required: true }) private advisor!: TargetTrackerAdvisor;
    @Prop({ required: true }) private partnerPracticeId!: string;

    private isLoading: boolean = false;

    private selectedAppointment: Appointment | null = null;
    private selectedPayment: TargetTrackerAppointmentPayment | null = null;
    private selectedPaymentStatusType: AppointmentPaymentStatusType | null = null;

    private showViewAppointmentDialog: boolean = false;
    private showEditAppointmentOutcomeDialog: boolean = false;
    private showAssignAdvisorDialog: boolean = false;
    private showEditPaymentDialog: boolean = false;

    private get predictedBanking(): number {
        const clearedAmount = this.appointments(TargetTrackerAppointmentPaymentType.ClearedPayment)
            .map((appointment) => appointment.payments.reduce((total, current) => total + current.value!, 0))
            .reduce((total, current) => total + current, 0);

        const bankedAmount = this.appointments(TargetTrackerAppointmentPaymentType.BankedPayment)
            .map((appointment) => appointment.payments.reduce((total, current) => total + current.value!, 0))
            .reduce((total, current) => total + current, 0);

        const signingBookedAmount = this.appointments(TargetTrackerAppointmentPaymentType.SigningBooked)
            .map((appointment) => appointment.payments.reduce((total, current) => total + current.instructedValue!, 0))
            .reduce((total, current) => total + current, 0);

        return clearedAmount + bankedAmount + signingBookedAmount;
    }

    private get differenceToTarget(): number | null {
        return this.advisor.targetAmount == null ? null : this.advisor.targetAmount - this.predictedBanking;
    }

    private canEdit(item: TargetTrackerDetail): boolean {
        return this.isInternalKeyStakeholder || this.isHeadOfDepartment ? true : this.currentUser.id! === item.ownerId;
    }

    private async onViewAppointmentAsync(appointmentId: string): Promise<void> {
        try {
            this.isLoading = true;

            this.selectedAppointment = await appointmentApi.getAppointmentByIdAsync(appointmentId);

            this.showViewAppointmentDialog = true;
        } catch (e) {
            if (e instanceof Forbidden) {
                this.$router.push({ name: 'forbidden' });
            } else if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: `Could not appointment. Please try again.`, type: 'is-danger' });
            }
        }

        this.isLoading = false;
    }

    private async onEditAppointmentOutcomeAsync(appointmentId: string): Promise<void> {
        try {
            this.isLoading = true;

            this.selectedAppointment = await appointmentApi.getAppointmentByIdAsync(appointmentId);

            this.showEditAppointmentOutcomeDialog = true;
        } catch (e) {
            if (e instanceof Forbidden) {
                this.$router.push({ name: 'forbidden' });
            } else if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: `Could not appointment. Please try again.`, type: 'is-danger' });
            }
        }

        this.isLoading = false;
    }

    private onMoveTo(item: TargetTrackerDetail): void {
        this.selectedPayment = { ...item };
        this.showAssignAdvisorDialog = true;
    }

    private onChangeToSigningPending(item: TargetTrackerDetail): void {
        this.selectedPayment = { ...item };
        this.selectedPaymentStatusType = this.appointmentPaymentStatusTypes.find((type) => type.isSigningPending)!;
        this.showEditPaymentDialog = true;
    }

    private onChangeToSigningBooked(item: TargetTrackerDetail): void {
        this.selectedPayment = { ...item };
        this.selectedPaymentStatusType = this.appointmentPaymentStatusTypes.find((type) => type.isSigningBooked)!;
        this.showEditPaymentDialog = true;
    }

    private onChangeToPartPayment(item: TargetTrackerDetail): void {
        this.selectedPayment = { ...item };
        this.selectedPaymentStatusType = this.appointmentPaymentStatusTypes.find((type) => type.isPartPayment)!;
        this.showEditPaymentDialog = true;
    }

    private onChangeToBanked(item: TargetTrackerDetail): void {
        this.selectedPayment = { ...item };
        this.selectedPaymentStatusType = this.appointmentPaymentStatusTypes.find((type) => type.isBanked)!;
        this.showEditPaymentDialog = true;
    }

    private onChangeToCleared(item: TargetTrackerDetail): void {
        this.selectedPayment = { ...item };
        this.selectedPaymentStatusType = this.appointmentPaymentStatusTypes.find((type) => type.isCleared)!;
        this.showEditPaymentDialog = true;
    }

    private onChangeToDebtor(item: TargetTrackerDetail): void {
        this.selectedPayment = { ...item };
        this.selectedPaymentStatusType = this.appointmentPaymentStatusTypes.find((type) => type.isDebtor)!;
        this.showEditPaymentDialog = true;
    }

    private onChangeToNoLongerProceeding(item: TargetTrackerDetail): void {
        this.selectedPayment = { ...item };
        this.selectedPaymentStatusType = this.appointmentPaymentStatusTypes.find((type) => type.isNoLongerProceeding)!;
        this.showEditPaymentDialog = true;
    }

    private onChangeToWrittenOff(item: TargetTrackerDetail): void {
        this.selectedPayment = { ...item };
        this.selectedPaymentStatusType = this.appointmentPaymentStatusTypes.find((type) => type.isWrittenOff)!;
        this.showEditPaymentDialog = true;
    }

    private onAppointmentOutcomeUpdated(): void {
        this.$snackbar.open({ message: `Appointment outcome successfully updated.`, type: 'is-success' });
        this.onCancel();

        this.$emit('refresh', this.advisor.id);
    }

    private onAdvisorAssigned(advisorName: string): void {
        this.$snackbar.open({ message: `Payment has been assigned to '${advisorName}'.`, type: 'is-success' });
        this.onCancel();

        this.$emit('refresh', this.advisor.id);
    }

    private onPaymentUpdated(): void {
        this.$snackbar.open({ message: `Payment has been successfully updated.`, type: 'is-success' });
        this.onCancel();

        this.$emit('refresh', this.advisor.id);
    }

    private onCancel(): void {
        this.showViewAppointmentDialog = false;
        this.showEditAppointmentOutcomeDialog = false;
        this.showAssignAdvisorDialog = false;
        this.showEditPaymentDialog = false;

        this.selectedAppointment = null;
        this.selectedPayment = null;
        this.selectedPaymentStatusType = null;
    }

    private appointments(type: number): Array<TargetTrackerAppointment> {
        const appointments = this.advisor.appointments.filter((appointment) =>
            appointment.payments.some((payment) =>
                payment.type === type));

        if (appointments == null) { return []; }

        return appointments.map((appointment) => {
            return {
                ...appointment,
                clients: [...appointment.clients],
                payments: [...appointment.payments.filter((payment) => payment.type === type)],
            };
        });
    }
}
